import React from "react";

import BuyPremiumPopup from "./BuyPremiumPopup";
import StatusPopup from "./StatusPopup";

/**
 * The premium popup and the payment-status popup, driven by useSandboxPremium's
 * `popups`. Neither shows while its homepage is out of sight.
 */
const SandboxPremiumPopups = ({
  isActive,
  premiumPopup,
  statusType,
  isStatusPopupOpen,
  countryName,
  isUpgrading,
  onCloseUpgrade,
  onUpgrade,
  onCloseStatus,
  onRetryPayment,
  onGoHome,
}) => (
  <>
    <BuyPremiumPopup
      isOpen={premiumPopup.isOpen && isActive}
      onClose={onCloseUpgrade}
      handleUpgradeClick={onUpgrade}
      loading={isUpgrading}
      data={premiumPopup.data}
      countryName={countryName}
      type={premiumPopup.type}
    />
    <StatusPopup
      isOpen={isStatusPopupOpen && isActive}
      onClose={onCloseStatus}
      status={statusType}
      onActionClick={statusType === "success" ? onGoHome : onRetryPayment}
      actionText={statusType === "success" ? "Go to Home" : "Retry Payment"}
    />
  </>
);

export default SandboxPremiumPopups;
